import ExportPatrimoinePerLocalisationForm from './export-patrimone-per-localisation';
import ExportCollectionsPerLocalisationForm from './export-collections-per-localisation';
import PricingPreviewModal from './situation/pricing-preview-modal';
import {MODAL} from 'features/modal-notch/constants';

export default {
  [MODAL.PRICING_SITUATIONS]: PricingPreviewModal,
  [MODAL.EXPORT_PATRIMOINE]: ExportPatrimoinePerLocalisationForm,
  [MODAL.EXPORT_COLLECTIONS_LOCATIONS]: ExportCollectionsPerLocalisationForm,
};
